// @ts-nocheck
import { TrackPriceListExportParameters } from "@store/Framework/GoogleAnalytics/trackers/trackPriceListExport";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const usePriceListExport = (
    parameters: TrackPriceListExportParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => ga.util.getEventTrackerHook(ga.track.priceListExport, parameters, options);

export default usePriceListExport;
